import script from "./AdminPermissionsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPermissionsChart.vue?vue&type=script&setup=true&lang=js"

import "./AdminPermissionsChart.vue?vue&type=style&index=0&id=c36ae02c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36ae02c"]])

export default __exports__